<template>
  <div>
    <div :class="$style.maincontainer">
      <h4>Welcome back, Creator.</h4>
      <h1 :class="$style.header">Log In to Your Account</h1>
      <!-- <div class="mb-4">
        <a-radio-group
          :value="settings.authProvider"
          @change="e => changeAuthProvider(e.target.value)"
        >
          <a-radio value="firebase">Firebase</a-radio>
          <a-radio value="jwt">JWT</a-radio>
        </a-radio-group>
      </div> -->
      <div :class="$style.container">
        <a-form class="mb-4" :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              size="large"
              placeholder="Email"
              v-decorator="['email', { rules: [{ required: true, message: 'Please input your username!' }]}]"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              size="large"
              placeholder="Password"
              type="password"
              v-decorator="['password', { rules: [{ required: true, message: 'Please input your Password!' }]}]"
            />
          </a-form-item>
          <a-button
            htmlType="submit"
            size="large"
            class="text-center w-100 btn btn-sales"
            :loading="loading"
          >
            <strong>Sign in</strong>
          </a-button>
        </a-form>
        <router-link to="/auth/forgot-password" class="kit__utils__link font-size-16">Forgot Password?</router-link>
      </div>
      <div class="text-center pt-2 mb-auto">
        <span class="mr-2">Don't have an account?</span>
        <a href="https://tryplannervid.com" class="kit__utils__link font-size-16">FREE TRIAL</a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'CuiLogin',
  computed: {
    ...mapState(['settings']),
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
    }
  },
  methods: {
    // changeAuthProvider(value) {
    //   this.$store.commit('CHANGE_SETTING', { setting: 'authProvider', value })
    // },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('user/LOGIN', { payload: values })
          this.$router.push('/dashboard')
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
